export * from './Chat';
export * from './ChatNext';
export * from './Conversation';
export * from './ClientProvider';
export * from './DotComButton';
export * from './Widget';
export * from './theme';
export * from './AnalyticsProvider';
export * from './ThemeProvider';
export * from './SalesProvider';
export * from './RequestACall';
export * from './SendUsAnEmail';
export * from './Link';
export {FileUploaderProvider, useFileUploader} from './FileUploaderProvider';
export type {FileUploaderValue} from './FileUploaderProvider';
export type {FeatureFlags} from './FeatureFlagsProvider';
export {
  FeatureFlagsProvider,
  useConversationUIFeatureFlags,
  useDotComFeedbackButtons,
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
  useInlineRacEmailForm,
  useUniversalHelpDrawerEnabled,
} from './FeatureFlagsProvider';
export {widgetLinkAction} from './helpers/widgetLinkAction';

export const ANIMATION_DURATION = 350;

export {useItemsGroupedV2} from './helpers/useItemsGroupedV2';
export {GroupedMessagesRowV2} from './Conversation/Log/Messages/GroupedMessagesRowV2';
export {LoadingText, LoadingTextProvider} from './Conversation/LoadingText';
export {
  useMessagesTopAnchored,
  TopAnchoringConfigProvider,
} from './helpers/useMessagesTopAnchored';
export {LiveAnswersResponse} from './StripeAssistant/LiveAnswersV2/LiveAnswersResponse';
export {LiveAnswersResponseContainer} from './StripeAssistant/LiveAnswersV2/LiveAnswersResponseContainer';
export {smoothScrollToWithBezier} from './helpers/smoothScrollTo';
export {
  shouldHideMessageAfterThumbsDownAdvance,
  isButtonOptionsMessage,
  isInlineDataMessage,
} from './helpers/message-added';
